/**
* Implements a set of static functions for time manipulations
*/
export class Time {
    /** Java ticks of J2000 epoch */
    static readonly J2000_TIME = 946728000000;
    static readonly TICKS_PER_DAY = 86400 * 1000;
    static readonly TICKS_PER_HOUR = 3600 * 1000;
    static readonly TICKS_PER_MINUTE = 60 * 1000;
    static readonly JAVA_EPOCH_MJD = 40587;

    /** Gets the time in Julian centuries from the J2000 epoch
    * @param {number} t The time in Java ticks
    */
    static getCenturiesSinceJ2000(t: number): number {
        let ticks = t - Time.J2000_TIME;
        return ticks / (36525 * 86400000);
    }

    /** Converts the given Modified Julian Day Number to Javascript ticks */
    static mjdToTicks(mjd: number): number {
        return (mjd - this.JAVA_EPOCH_MJD) * this.TICKS_PER_DAY;
    }

    /** Converts the given Javascript ticks to a Modified Julian Day Number */
    static ticksToMjd(ticks: number): number {
        return this.JAVA_EPOCH_MJD + ticks / this.TICKS_PER_DAY;
    }

    static get utcNow() {
        return new Date().getTime();
    }
}



// WEBPACK FOOTER //
// ./src/Time.ts